<section class="email-activity" data-testid="email-activity">
    <header class="section-head">
        <div>
            <h2>Email Activity</h2>
            <p>Recruiter contact sends across all partner companies — drill from companies to individual messages.</p>
        </div>

        <div class="toolbar">
            <div class="date-presets" role="group" aria-label="Date range">
                <button type="button" [class.active]="datePreset === '7d'" (click)="SetPreset('7d')">7d</button>
                <button type="button" [class.active]="datePreset === '30d'" (click)="SetPreset('30d')">30d</button>
                <button type="button" [class.active]="datePreset === '90d'" (click)="SetPreset('90d')">90d</button>
                <button type="button" [class.active]="datePreset === 'all'" (click)="SetPreset('all')">All</button>
                <button type="button" [class.active]="datePreset === 'custom'" (click)="SetPreset('custom')">Custom</button>
            </div>
            <div class="custom-range" *ngIf="datePreset === 'custom'">
                <label>
                    <span>From</span>
                    <input type="date" [(ngModel)]="customFrom" (change)="OnCustomDateChange()" aria-label="Custom range start date" />
                </label>
                <label>
                    <span>To</span>
                    <input type="date" [(ngModel)]="customTo" (change)="OnCustomDateChange()" aria-label="Custom range end date" />
                </label>
            </div>

            <div class="mode-chips" role="group" aria-label="Delivery modes">
                <button
                    type="button"
                    class="chip"
                    *ngFor="let mode of allModes"
                    [class.on]="IsModeOn(mode)"
                    [attr.aria-pressed]="IsModeOn(mode)"
                    (click)="ToggleMode(mode)">
                    {{ mode }}
                </button>
            </div>

            <div class="export-anchor">
                <button type="button" class="export-btn" [class.open]="isExportOpen" (click)="ToggleExport()" data-testid="email-export">
                    Export events
                </button>
                <div class="popover" *ngIf="isExportOpen" role="dialog" aria-label="Export email events">
                    <p class="popover-hint">Exports the raw event table for the current filters and drill position.</p>
                    <fieldset>
                        <legend>Event types</legend>
                        <label class="type-row" *ngFor="let type of allEventTypes">
                            <input #typeBox type="checkbox" [checked]="IsEventTypeOn(type)" (change)="ToggleEventType(type, typeBox)" [disabled]="isExporting" />
                            <span>{{ type }}</span>
                        </label>
                    </fieldset>
                    <label class="format-pick">
                        <span>Format</span>
                        <select [(ngModel)]="exportFormat" [disabled]="isExporting">
                            <option value="csv">CSV</option>
                            <option value="xlsx">XLSX</option>
                        </select>
                    </label>
                    <button type="button" class="run-export" (click)="RunExport()" [disabled]="isExporting" data-testid="email-export-run">
                        {{ isExporting ? 'Exporting…' : 'Export' }}
                    </button>
                </div>
            </div>
        </div>
    </header>

    <div class="kpi-row" *ngIf="!errorMessage" data-testid="email-kpis">
        <div class="kpi"><span class="kpi-value">{{ kpis.messages }}</span><span class="kpi-label">Messages</span></div>
        <div class="kpi"><span class="kpi-value">{{ kpis.sent }}</span><span class="kpi-label">Sent</span></div>
        <div class="kpi"><span class="kpi-value">{{ kpis.delivered }}</span><span class="kpi-label">Delivered</span></div>
        <div class="kpi"><span class="kpi-value">{{ kpis.opened }}</span><span class="kpi-label">Opened · {{ kpis.openRateText }}</span></div>
        <div class="kpi"><span class="kpi-value">{{ kpis.clicked }}</span><span class="kpi-label">Clicked · {{ kpis.clickRateText }}</span></div>
        <div class="kpi"><span class="kpi-value">{{ kpis.bounced + kpis.failed }}</span><span class="kpi-label">Bounced / Failed</span></div>
    </div>

    <figure class="timeline-card" *ngIf="!errorMessage && timeline" data-testid="email-timeline"
            aria-label="Delivered, opened, and clicked email events over time">
        <figcaption class="timeline-head">
            <span class="timeline-title">Engagement over time{{ timeline.weekly ? ' (weekly buckets)' : '' }}</span>
            <span class="timeline-legend" aria-hidden="false">
                <span class="legend-item" *ngFor="let s of timeline.series">
                    <span class="legend-swatch" [style.background]="s.color"></span>{{ s.label }} ({{ s.total }})
                </span>
            </span>
        </figcaption>
        <div class="timeline-plot">
            <svg [attr.viewBox]="'0 0 ' + chartW + ' ' + chartH" preserveAspectRatio="none" role="img"
                 aria-label="Line chart of delivered, opened, and clicked event counts per period"
                 (mousemove)="OnChartMove($event)" (mouseleave)="OnChartLeave()">
                <!-- recessive grid + y labels -->
                <g *ngFor="let t of timeline.yTicks">
                    <line class="gridline" [attr.x1]="chartM.left" [attr.x2]="chartW - chartM.right" [attr.y1]="t.y" [attr.y2]="t.y"></line>
                    <text class="axis-label" [attr.x]="chartM.left - 6" [attr.y]="t.y + 3" text-anchor="end">{{ t.label }}</text>
                </g>
                <!-- x labels -->
                <text class="axis-label" *ngFor="let t of timeline.xTicks" [attr.x]="t.x" [attr.y]="chartH - 8" text-anchor="middle">{{ t.label }}</text>
                <!-- hover crosshair -->
                <line class="crosshair" *ngIf="hoverIndex !== null"
                      [attr.x1]="timeline.bucketXs[hoverIndex]" [attr.x2]="timeline.bucketXs[hoverIndex]"
                      [attr.y1]="chartM.top" [attr.y2]="chartH - chartM.bottom"></line>
                <!-- series lines, markers, end labels -->
                <g *ngFor="let s of timeline.series">
                    <path [attr.d]="s.path" fill="none" [attr.stroke]="s.color" stroke-width="2" stroke-linejoin="round" stroke-linecap="round"></path>
                    <circle *ngFor="let m of s.markers" [attr.cx]="m.x" [attr.cy]="m.y" r="4" [attr.fill]="s.color" stroke="#fff" stroke-width="2"></circle>
                    <text class="end-label" [attr.x]="chartW - chartM.right + 10" [attr.y]="s.endLabelY + 3">{{ s.label }}</text>
                </g>
            </svg>
            <div class="timeline-tooltip" *ngIf="hoverIndex !== null" [style.left.%]="hoverXPercent" role="status">
                <span class="tooltip-title">{{ timeline.tooltips[hoverIndex].title }}</span>
                <span class="tooltip-line" *ngFor="let line of timeline.tooltips[hoverIndex].lines">{{ line }}</span>
            </div>
        </div>
    </figure>
    <p class="timeline-empty" *ngIf="!isLoading && !errorMessage && !timeline" role="status">
        No delivery events in this period — engagement tracking begins once real-transport sends occur.
    </p>

    <nav class="crumbs" aria-label="Email activity drill path" *ngIf="crumbs.length > 0">
        <button type="button" class="crumb" (click)="AscendTo(-1)">All companies</button>
        <ng-container *ngFor="let crumb of crumbs; let i = index; trackBy: TrackByCrumb">
            <span class="crumb-sep" aria-hidden="true">›</span>
            <button type="button" class="crumb" [disabled]="i === crumbs.length - 1" (click)="AscendTo(i)">{{ crumb.label }}</button>
        </ng-container>
    </nav>

    <p *ngIf="isLoading" class="status">Loading…</p>
    <p *ngIf="errorMessage" class="status error" role="alert">{{ errorMessage }}</p>

    <ng-container *ngIf="!isLoading && !errorMessage">
        <!-- Aggregate grains: companies / senders / recipients -->
        <ng-container *ngIf="!atMessageLevel">
            <p *ngIf="activityRows.length === 0" class="empty" role="status">No email activity for these filters.</p>

            <table *ngIf="activityRows.length > 0" class="admin-table" data-testid="email-activity-table">
                <thead>
                    <tr>
                        <th>{{ levelLabel }}</th>
                        <th class="num">Messages</th>
                        <th class="num">Sent</th>
                        <th class="num">Delivered</th>
                        <th class="num">Opened</th>
                        <th class="num">Clicked</th>
                        <th class="num">Bounced</th>
                        <th class="num">Failed</th>
                        <th>Last Activity</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let row of activityRows; trackBy: TrackByKey">
                        <td>
                            <button type="button" class="drill-link" (click)="DrillInto(row)">{{ row.label }}</button>
                            <span class="secondary" *ngIf="row.secondary">{{ row.secondary }}</span>
                        </td>
                        <td class="num">{{ row.messages }}</td>
                        <td class="num">{{ row.sent }}</td>
                        <td class="num">{{ row.delivered }}</td>
                        <td class="num">{{ row.opened }} <span class="rate">{{ row.openRateText }}</span></td>
                        <td class="num">{{ row.clicked }} <span class="rate">{{ row.clickRateText }}</span></td>
                        <td class="num">{{ row.bounced }}</td>
                        <td class="num">{{ row.failed }}</td>
                        <td>{{ row.lastActivityText }}</td>
                    </tr>
                </tbody>
            </table>
        </ng-container>

        <!-- Message level -->
        <ng-container *ngIf="atMessageLevel">
            <p *ngIf="messageRows.length === 0" class="empty" role="status">No messages for these filters.</p>

            <table *ngIf="messageRows.length > 0" class="admin-table" data-testid="email-messages-table">
                <thead>
                    <tr>
                        <th>Subject</th>
                        <th>Recipient</th>
                        <th>Mode</th>
                        <th>Status</th>
                        <th class="num">Engagement</th>
                        <th>Sent</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let row of messageRows; trackBy: TrackByMessageId">
                        <td><button type="button" class="drill-link" (click)="OpenDetail(row)">{{ row.subject }}</button></td>
                        <td>
                            {{ row.recipientName || row.recipientEmail }}
                            <span class="secondary" *ngIf="row.recipientName">{{ row.recipientEmail }}</span>
                        </td>
                        <td><span class="mode-badge" [class]="'mode-badge mode-' + row.deliveryMode">{{ row.deliveryMode }}</span></td>
                        <td>
                            <span class="status-text" [class.ok]="row.status === 'Delivered' || row.status === 'Opened' || row.status === 'Clicked'"
                                  [class.bad]="row.status === 'Bounced' || row.status === 'Dropped' || row.status === 'Spam' || row.status === 'Failed'">
                                {{ row.status }}
                            </span>
                        </td>
                        <td class="num">{{ row.engagementText }}</td>
                        <td>{{ row.createdAtText }}</td>
                    </tr>
                </tbody>
            </table>

            <maps-pagination
                *ngIf="messageTotal > 0"
                itemNoun="message"
                [currentPage]="messagePage"
                [totalItems]="messageTotal"
                [pageSize]="messagePageSize"
                (pageChange)="OnPageChange($event)"
                (pageSizeChange)="OnPageSizeChange($event)">
            </maps-pagination>
        </ng-container>
    </ng-container>

    <!-- Message detail drawer -->
    <maps-drawer *ngIf="detailVm" label="Email message detail" variant="drawer" [wide]="true" (closed)="CloseDetail()">
        <ng-container drawerTitle>
            <h2 class="drawer-title" data-testid="email-detail-title">{{ detailVm.detail.message.subject }}</h2>
        </ng-container>

        <div class="detail-body">
            <dl class="meta">
                <div><dt>Company</dt><dd>{{ detailVm.detail.message.companyName }}</dd></div>
                <div><dt>Sender</dt><dd>{{ detailVm.senderText }}</dd></div>
                <div><dt>Recipient</dt><dd>{{ detailVm.detail.message.recipientName || detailVm.detail.message.recipientEmail }} <span class="secondary" *ngIf="detailVm.detail.message.recipientName">{{ detailVm.detail.message.recipientEmail }}</span></dd></div>
                <div><dt>Mode</dt><dd><span class="mode-badge" [class]="'mode-badge mode-' + detailVm.detail.message.deliveryMode">{{ detailVm.detail.message.deliveryMode }}</span></dd></div>
                <div *ngIf="detailVm.detail.message.redirectedTo"><dt>Redirected to</dt><dd>{{ detailVm.detail.message.redirectedTo }}</dd></div>
                <div><dt>Status</dt><dd>{{ detailVm.detail.message.status }}</dd></div>
                <div><dt>Created</dt><dd>{{ detailVm.createdAtText }}</dd></div>
                <div *ngIf="detailVm.sentAtText"><dt>Sent</dt><dd>{{ detailVm.sentAtText }}</dd></div>
                <div *ngIf="detailVm.detail.sgMessageId"><dt>SendGrid ID</dt><dd class="mono">{{ detailVm.detail.sgMessageId }}</dd></div>
                <div *ngIf="detailVm.detail.inviteId"><dt>Link invite</dt><dd class="mono">{{ detailVm.detail.inviteId }}</dd></div>
                <div *ngIf="detailVm.detail.errorMessage"><dt>Error</dt><dd class="error-text">{{ detailVm.detail.errorMessage }}</dd></div>
                <div *ngIf="detailVm.detail.message.bounceReason"><dt>Bounce reason</dt><dd class="error-text">{{ detailVm.detail.message.bounceReason }}</dd></div>
            </dl>

            <h3>Message</h3>
            <div class="message-body">
                <p *ngFor="let line of detailVm.bodyLines">{{ line || ' ' }}</p>
            </div>

            <h3>Delivery events</h3>
            <p *ngIf="detailVm.events.length === 0" class="empty" role="status">
                No delivery events — test rehearsals (dryrun/sandbox) never produce SendGrid events.
            </p>
            <ol class="timeline" *ngIf="detailVm.events.length > 0">
                <li *ngFor="let event of detailVm.events">
                    <span class="event-type">{{ event.eventType }}</span>
                    <span class="event-at">{{ event.occurredAtText }}</span>
                    <span class="event-extra" *ngIf="event.url">{{ event.url }}</span>
                    <span class="event-extra error-text" *ngIf="event.reason">{{ event.reason }}</span>
                </li>
            </ol>
        </div>
    </maps-drawer>
</section>
